import styled from "styled-components";
import * as global from './../helpers/Helper'

export const MenuContainer = styled.section`
  max-width: 1400px;
  width: 95%;
  margin: 0 auto;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`
export const MenuGrid = styled.div`
  display: grid;
  gap: 12px;
  @media (min-width: 650px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 18px;
  }
`
export const MenuItem = styled.article`
  background-color: ${global.ColorMain};
  border-radius: 50px;
  width: 100%;
  padding: 18px 12px;
  text-align: center;
  display: grid;
  gap: 12px;
  & h3 {
    font-size: 24px;
    line-height: 24px;
    color: ${global.ColorSec};
    text-align: center;
    @media (min-width: 992px) {
      font-size: 30px;
      line-height: 30px;
    }
  }
  & img {
    max-width: 100%;
  }
  & p {
    font-size: 18px;
    line-height: 26px;
    color: ${global.ColorSec};
    text-align: start;
    @media (min-width: 992px) {
      font-size: 22px;
      line-height: 30px;
    }
  }
  & span {
    font-size: 24px;
    line-height: 24px;
    font-family: ${global.FontSigmar};
    background-color: ${global.ColorSec};
    color: ${global.ColorWhite};
    border-radius: 10px;
    padding: 3px 0;
    width: 140px;
    margin: 0 auto;
    @media (min-width: 992px) {
      font-size: 30px;
      line-height: 30px;
      padding: 6px 0;
    }
  }
`
